import styled from 'styled-components';
import Colors from 'assets/Colors';

const Container = styled.div`
  width: 100%;
  background: ${Colors.BG_Header_Card};
  color: ${Colors.text_on_primary};
  margin-bottom: 25px;
  border-radius: 5px;
  padding-left: 21px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  height: 60px;
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.01em;
`;

const TextContainer = styled.p`
  margin-bottom: 0;
  margin-top: 0;
`;

export default {
  Container,
  TextContainer,
};
